import type { ReactElement } from 'react';

import type { FCC } from '../../types/common';
import PageBlock from '../../ui/page_block/page_block';

import styles from './block.module.css';

type Props = {
  className?: string;
  contentClassName?: string;
  title?: string;
  actionElements?: ReactElement[];
  scrollable?: boolean;
  uiKey?: string;
};

const StyleguideBlock: FCC<Props> = (props) => (
  <PageBlock {...props} className={styles.block}>
    {props.children}
  </PageBlock>
);

export default StyleguideBlock;
